
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface CartSummaryProps {
  total: number;
  onCheckout: () => void;
  isLoading: boolean;
  isCheckoutDisabled: boolean;
}

export const CartSummary = ({ 
  total, 
  onCheckout, 
  isLoading, 
  isCheckoutDisabled,
}: CartSummaryProps) => {
  return (
    <div className="bg-card rounded-lg p-6 space-y-4 sticky bottom-0 mt-8">
      <div className="space-y-2">
        <div className="flex justify-between items-center text-lg font-semibold pt-2 border-t mt-2">
          <span>Total</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button 
          className="w-full sm:flex-1" 
          size="lg"
          onClick={onCheckout}
          disabled={isLoading || isCheckoutDisabled}
        >
          {isLoading ? "Processing..." : "Checkout"}
        </Button>
        <Link to="/" className="w-full sm:flex-1">
          <Button 
            variant="outline" 
            className="w-full"
          >
            Continue Shopping
          </Button>
        </Link>
      </div>
    </div>
  );
};
